import { appConfig } from 'utils/app.config';

export const userClaimableList = [
  ...(appConfig.isProduction === false
    ? [
        {
          projectClaimContractAddress:
            '0x2D26695b2863f125E390330DAA63ffB7667C22EE',
          poolId: 0,
          poolChainId: 11155111,
          sfiToken: '0x9a3f60032941C91cdeF5dBB58f2cE80e47e3ddCA',
          symbol: 'SFI',
          decimals: 18,
        },
      ]
    : []),
  {
    projectClaimContractAddress: '0x10C096Fb4b3db5f257402E896f7BA03CB21F6260',
    poolId: 3,
    poolChainId: 1,
    sfiToken: '0xb6ecf70F4555627eC8Fc615b17A1ef624140793F',
    symbol: 'RJV',
    decimals: 18,
  },
  {
    projectClaimContractAddress: '0xa53DB120A4af6361c9eF1f13e6d32368c93FB7Ee',
    poolId: 3,
    poolChainId: 1,
    sfiToken: '0xCe0cC1bBd23Db9F661928C08249c650DFFFbd07f',
    symbol: 'SOPH',
    decimals: 18,
  },
  {
    projectClaimContractAddress: '0xa53DB120A4af6361c9eF1f13e6d32368c93FB7Ee',
    poolId: 5,
    poolChainId: 1,
    sfiToken: '0xCe0cC1bBd23Db9F661928C08249c650DFFFbd07f',
    symbol: 'SOPH',
    decimals: 18,
  },
  {
    projectClaimContractAddress: '0x731923760C28426951D0C3d81fa0aBB427f77510',
    poolId: 0,
    poolChainId: 1,
    sfiToken: '0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
    symbol: 'SFI',
    decimals: 18,
  },
];

export const userClaimableListTestnet = {
  projectClaimContractAddress: '0x7D32287B9C3b0ff508a19cDBe0834480b0e15Ac7',
  poolId: 0,
  poolChainId: 1,
  sfiToken: '0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
  symbol: 'SFI',
  decimals: 18,
};
